import React, { useEffect, useState } from 'react';
import { BsPlus } from 'react-icons/bs';
import { useNavigate } from 'react-router';
import { getPermission} from '../../../Conexiones/Conexion';
import { Button, CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { FaArrowLeftLong } from 'react-icons/fa6';
import { errorMessage, errorToast, successToast, warningModal, warningToast } from '../../../Utils/AlertMessage';
import { deleteApi, getApi, postApi, putApi } from '../../../Conexiones/Models';
import Loading from '../../../Utils/Loading';

function ThirdSubCat() {
    const [subActividades, setsubActividades] = useState([]);
    const [nombreCat, setNombreCat] = useState();
    const navigate = useNavigate();
    const num=parseInt(sessionStorage.getItem("subAct"));
    const [isLoading,setIsLoading]=useState(false);
    const uri = 'thirdActividades/';

    //console.log(num)
    const [busqueda, setBusqueda] = useState("");
    const [tablaAct, setTablaAct] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;
    //AGREGAR
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);
    const [nombre, setNombre] = useState();
    const [isSaving, setSaving] = useState(false);
    const [unidad, setUnidad] = useState("");
    const [unidades,setUnidades]=useState([]);

     //EDITAR
     const [showEdit, setShowEdit] = useState(false);
     const handleCloseEdit = () => setShowEdit(false);
     const [editNombre,setEditNombre] = useState ();
     const [idUnidad,setidUnidad]=useState();
     const [nombreUnidad,setNombredUnidad]=useState();
     const [idAct,setIdAct] = useState ();
     const [idCat,setIdCat] = useState ();
     const handleShowEdit = (id,nombre,idCat,nomUnidad) =>{
        setShowEdit(true);
        setNombredUnidad(nomUnidad);
        setEditNombre(nombre);
        setIdAct(id);
        setIdCat(idCat);
    } 

    const getThirdSubAct = async () => {
        const endpoint = uri+num
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setsubActividades(res.data);
                setTablaAct(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    };
    useEffect(() => {
        const getThirdSubAct = async () => {
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,0);
            if(permiso){
                const endpoint = 'thirdActivities/'+num
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setsubActividades(res.data[0].thirdActividades);
                        setTablaAct(res.data[0].thirdActividades);
                        setUnidades(res.data[0].unidades);
                        setNombreCat(res.data[0].nombreCat);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        };
        getThirdSubAct();
    },[idUsuario,navigate,num]);
    
    const handleSelectChange = (event) =>{
        setUnidad(event.value);
    }

    const handleSelectChangeEdit = (event) =>{
        //console.log("valor "+event.value)
        setidUnidad(event.value);
    }

    const regresar = () => {
        navigate('/inicio/Catalogos/Actividades/SubActividades');
    }

    const buscar = e => {
        setBusqueda(e.target.value);
        filtrar(e.target.value);
    }

    const filtrar = (texto) => {
        var resBusqueda = tablaAct.filter((elemento)=> {
            if  (elemento.nombreThird.toString().toLowerCase().includes(texto.toLowerCase())){  
                return elemento;
            }
            return resBusqueda;
        })
        setsubActividades(resBusqueda);
    }

    //ELIMINAR ACTIVIDAD
    const eliminarAct = (id) => {
        warningModal('¿QUIERES ELIMINAR ESTA CATEGORIA?')
        .then(async (result)  => {
            if (result.isConfirmed) {
                const endpoint = 'eliminarAct/'+id+"/"+3;
                const res = await deleteApi(endpoint);
                if(res.status === 1){
                    if(res.data.message==="registro eliminado"){
                        getThirdSubAct();
                        successToast("ELIMINADO");
                    }else{
                        errorToast("¡ERROR!",res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }
        })
    }

    //AGREGAR ACTIVIDAD
    const store = async (e) =>{
        e.preventDefault()
        setSaving(true);
        if(nombre.trim().length === 0 || unidad === ""){
            warningToast('CAMPOS VACIOS','LLENAR TODOS LOS CAMPOS');
        }else{
            const num=parseInt(sessionStorage.getItem("subAct"));
            const data ={nombreAct:nombre,idCatAct:num,idUnidad:unidad};
            const endpoint = uri;
            const res = await postApi(endpoint,data)
            if(res.status === 1){
                if(res.data.message==="¡Registro creado correctamente!"){
                    handleClose();
                    getThirdSubAct();
                    successToast("agregado");
                }else{
                    errorToast("¡error!", res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }

    //EDITAR ACTIVIDAD
    const update= async (e) => {
        e.preventDefault()
        if(editNombre.trim().length === 0){
            warningToast('CAMPOS VACIOS','EL CAMPO NOMBRE ESTA VACÍO');
        }else{
            const endpoint = 'updateThirActividad/'+idAct;
            const data = {nombreAct:editNombre,idCatAct:idCat,idUnidad:idUnidad};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="Registro modificado"){
                    handleCloseEdit();
                    getThirdSubAct();
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }

    const valorId=  idUnidad;
    const etiqueta = nombreUnidad;

    return (
        <div className='herramientas' >
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">{nombreCat}</label>
                    </div>
                    <div className='divbotonA' >                                                                                             
                        <div className='botonA' style={{display:'flex', justifyContent:'space-between'}} >
                            <button title='Agregar Area' style={{justifyContent:'center'}} className="btn btn-light btncolor" onClick={handleShow} type="button">
                                <label className="agregar">ACTIVIDAD</label><BsPlus style={{fontSize:'25px'}}/>
                            </button>
                            <input type="search" placeholder="Buscar" value={busqueda} onChange={buscar} className="form-control" style={{width:'50%'}} aria-describedby="basic-addon1"/> 
                        </div>
                    </div>
                    {subActividades.length === 0 ? (<h3 style={{marginTop:'30vh'}}>AUN NO HAY REGISTROS</h3>):(
                        <div className="tabla-cajaA" >
                            <div className="table tabla">
                                <table className="table table-hover table-bordered text-uppercase">
                                    <thead className="encabezado" style={{backgroundColor:"#7498b6"}}>
                                        <tr >                                
                                            <th>CODIGO</th>
                                            <th style={{width:'40%'}}>ACTIVIDAD</th>
                                            <th >UNIDAD</th>
                                            <th>EDITAR</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {subActividades.map(a =>{
                                            return(                                    
                                                <tr key={a.idThird} >                                       
                                                    <td valign="middle">{a.codigoThird}</td>                                    
                                                    <td valign="middle">{a.nombreThird}</td> 
                                                    <td valign="middle">{a.nombreUnidad}</td> 
                                                    <td>
                                                        <div className="btn iconoH" onClick={() => handleShowEdit(a.idThird,a.nombreThird,num,a.nombreUnidad)}  style={{margin:'5px'}}>
                                                            <span className="bi bi-pen" title="EDITAR"></span>
                                                        </div>
                                                        <div className="btn iconoH"  style={{margin:'5px'}} onClick={() => eliminarAct(a.idThird)}>
                                                            <span className="bi bi-trash" title="ELIMINAR"></span>
                                                        </div>
                                                    </td>                                                                                                
                                                </tr>                                                                        
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>      
                        </div>
                    )}

                    {/*AGREGAR ACTIVIDAD*/}
                    <Modal show={show} onHide={handleClose} id="modal-agregar-thirdActividad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR ACTIVIDAD</Modal.Title>
                            <CloseButton onClick={handleClose} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setNombre(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        classNamePrefix="select"
                                        placeholder="Seleccionar unidad..."
                                        defaultValue={unidades[0]}
                                        required
                                        options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                        onChange={handleSelectChange}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleClose}>CANCELAR</Button>                                               
                                {isSaving===true?
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>  

                    {/*EDITAR ACTIVIDAD*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-thirdActividad">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR ACTIVIDAD</Modal.Title>
                            <CloseButton onClick={handleCloseEdit} style={{backgroundColor:"white"}} />
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase">NOMBRE
                                        <label title="OBLIGATORIO" className="obligatorio">*</label>
                                    </label>
                                    <input type="text" className="form-control"  required defaultValue={editNombre} onChange={(e)=>setEditNombre(e.target.value)} aria-describedby="basic-addon1"/>   
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="text-uppercase" > unidad <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <Select
                                        defaultValue={{ label: etiqueta, value: valorId }}
                                        required
                                        options={unidades.map(tip=>({label:tip.nombreUnidad,value:tip.idUnidad}))}
                                        onChange={handleSelectChangeEdit}
                                    />
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</Button>                                               
                                {isSaving===true? 
                                    <Button className="btn btn-primary" type="button" disabled >
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </Button>:
                                    <Button type="submit" className="btn btn-light btncolor" >GUARDAR CAMBIOS</Button>                                                
                                }
                            </Modal.Footer>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    );
}

export default ThirdSubCat;